import type { Theme } from '../../types/theme';

export const lovableTheme: Theme = {
  id: 'lovable',
  name: 'Lovable',
  description: 'Playful gradients and friendly dev aesthetic for AI full-stack builder',
  sourceDesignMd: 'https://github.com/nexu-io/open-design/blob/main/design-systems/lovable/DESIGN.md',
  visualKeywords: ['playful', 'orange gradient', 'friendly', 'AI full-stack', 'gradient'],
  colors: {
    background: '#ffffff',
    surface: '#fff7ed',
    surfaceElevated: '#fff7ed',
    textPrimary: '#1a1a1a',
    textSecondary: '#737373',
    textMuted: '#737373',
    border: '#fed7aa',
    borderSubtle: '#f4cda0',
    primary: '#f97316',
    primaryHover: '#e55f02',
    primaryActive: '#db5500',
    accent: '#f97316',
    onPrimary: '#000000',
    success: '#22c55e',
    warning: '#f59e0b',
    error: '#ef4444',
  },
  typography: {
    headingFont: 'Inter, system-ui, sans-serif',
    bodyFont: 'Inter, system-ui, sans-serif',
    monoFont: 'JetBrains Mono, monospace',
    headingWeight: '600',
    bodyWeight: '400',
    letterSpacingHeading: '-0.02em',
    letterSpacingBody: '0',
  },
  radius: {
    button: '6px',
    card: '8px',
    panel: '8px',
    badge: '4px',
    input: '6px',
  },
  shadow: {
    card: '0 1px 3px rgba(0,0,0,0.1)',
    elevated: '0 4px 12px rgba(0,0,0,0.15)',
    button: '0 1px 2px rgba(0,0,0,0.1)',
    none: 'none',
  },
  layout: {
    maxWidth: '1280px',
    sectionSpacing: '80px',
    cardPadding: '24px',
    navHeight: '64px',
  },
  mood: {
    density: 'medium',
    tone: 'playful',
    productFit: [],
    bestFor: [],
    notGoodFor: [],
  },
};
